// import Login from './Login';
import React, { useEffect } from 'react';
import Home from './Home';
import Tizenbo from './Tizenbo';
import ListTizenbo from './ListTizenbo';
import DefaultSidebar from './Sidebar';
import ListUsers from './ListUsers'
import ListIdPdv from './ListIdPdv'
import ListArticles from './ListArticles';
import UploadFile from './UploadFile';
import FileManager from './FileManager';
import AnnuaireClient from './AnnuaireClient';
import AnnuaireServer from './AnnuaireServer';
import ListCallEat from './ListCallEat';
import PersoCallEat from './PersoCallEat';
import Wireguard from './wireguard';
import ListClientWireguard from './ListClientWireguard'
import AnnuaireAlta from './AnnuaireAlta'
import ListNonApprouve from './ListNonApprouve';
import Programme from './Programme';
import ListClientProgramme from './ListClientProgramme'
import Documentation from './Documentation';
import ImageManager from './ImageManager';
import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom'
import { loadCldr} from '@syncfusion/ej2-base';
import PrivateRoute from './PrivateRoute';
import ListProgramme from './ListProgramme'
import AnnuaireAltaClient from './AnnuaireAltaClient';
import ListAltaFidPdv from './ListAltaFidPdv';
import MainLayout from './MainLayout';
import ListLink from './ListLink';
import { ReactKeycloakProvider , useKeycloak } from '@react-keycloak/web';
import keycloak from './keycloak';
import ListVideowall from './ListVideowall'
import ModalVideoVideoWall from './ModalVideoVideoWall';
import DeploymentHistory from './DeploymentHistory';
import NowPlaying from './NowPlaying';
import MapPlayers from './MapPlayers';
loadCldr(
 require('cldr-data/supplemental/numberingSystems.json'),
 require('cldr-data/main/fr-CH/ca-gregorian.json'),
 require('cldr-data/main/fr-CH/numbers.json'),
 require('cldr-data/main/fr-CH/timeZoneNames.json')
  );

  const AutoRefreshToken = () => {
  const { keycloak, initialized } = useKeycloak();

  useEffect(() => {
    if (initialized && keycloak.authenticated) {
      console.log("Session active - Démarrage du rafraîchissement automatique");
      
      const timer = setInterval(() => {
        // Vérifie si le token expire dans moins de 70 secondes
        // Si oui, il le rafraîchit
        keycloak.updateToken(70)
          .then((refreshed) => {
            if (refreshed) {
              console.log('Token rafraîchi avec succès');
            }
          })
          .catch(() => {
            console.error('Échec du rafraîchissement du token');
            keycloak.logout();
          });
      }, 60000); // Vérification toutes les minutes (60000 ms)

      // Nettoyage du timer quand le composant est démonté
      return () => clearInterval(timer);
    }
  }, [initialized, keycloak, keycloak.authenticated]);

  return null; // Ce composant n'affiche rien
};

function App(){
  const initOptions = {
    onLoad: 'login-required',
    checkLoginIframe: false // This disables the iframe-based session check
  };
  return (
    <ReactKeycloakProvider authClient={keycloak} initOptions={initOptions}>
      <AutoRefreshToken />
      <BrowserRouter>
        <Routes>
          {/* <Route path='/' element={<Login />} /> */}
          <Route element={<PrivateRoute element={MainLayout} />}>
            <Route path='/' element={<Navigate to="/home" replace />} />
            <Route path='/home' element={<Home />} />
            <Route path='/tizenbo' element={<Tizenbo />} />
            <Route path='/sidebar' element={<DefaultSidebar />} />
            <Route path='/listtizenbo' element={<ListTizenbo />} />
            <Route path='/listusers' element={<ListUsers />} />
            <Route path='/listidpdv' element={<ListIdPdv />} />
            <Route path='/listarticles/:id_pdv/:id_client' element={<ListArticles />} />
            <Route path='/uploadfile' element={<UploadFile />} />
            <Route path='/filemanager' element={<FileManager />} />
            <Route path='/annuaireclient' element={<AnnuaireClient />} />
            <Route path='/annuaireserver' element={<AnnuaireServer />} />
            <Route path='/listcalleat' element={<ListCallEat />} />
            <Route path='/perso-calleat' element={<PersoCallEat />} />
            <Route path='/wireguard' element={<Wireguard />} />
            <Route path='/listclientwireguard' element={<ListClientWireguard />} />
            <Route path='/listnonapprouve' element={<ListNonApprouve />} />
            <Route path='/programme/:_pin_code' element={<Programme />} />
            <Route path='/listclientprogramme' element={<ListClientProgramme />} />
            <Route path='/listprogramme' element={<ListProgramme />} />
            <Route path='/documentation' element={<Documentation />} />
            <Route path='/imagemanager/:id_pdv?' element={<ImageManager />} />
            <Route path='/annuairealtaclient' element={<AnnuaireAltaClient />} />
            <Route path='/annuairealta/:id_client' element={<AnnuaireAlta />} />
            <Route path='/listaltafidpdv' element={<ListAltaFidPdv />} />
            <Route path='/listlink' element={<ListLink />} />
            <Route path='/listvideowall' element={<ListVideowall />} />
            <Route path='/deployment-history' element={<DeploymentHistory />} />
            <Route path='/nowplaying' element={<NowPlaying />} />
            <Route path='/mapplayers' element={<MapPlayers />} />
            <Route path="/videowall/:idMaster/:pinMaster" element={<ModalVideoVideoWall />} />
          </Route>

        </Routes>
      </BrowserRouter>
    </ReactKeycloakProvider>
  )
}

export default App;
